module.exports = __webpack_public_path__ + "images/category_lp/pc/header-logo_479f1ee73b749094529b42f6c0a859ea.png";